var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-btn",
    {
      attrs: { icon: "", loading: _setup.loading },
      on: { click: _setup.excelExport },
    },
    [_c("v-icon", [_vm._v("mdi-microsoft-excel")])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }